/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["en-Shaw",[["𐑨𐑥","𐑐𐑥"]],u,[["𐑕","𐑥","𐑑","𐑢","𐑔","𐑓","𐑕"],["·𐑕𐑭","·𐑥𐑭","·𐑑𐑵","·𐑢𐑧","·𐑔𐑻","·𐑓𐑮","·𐑕𐑨"],["·𐑕𐑭𐑙𐑛𐑱","·𐑥𐑭𐑙𐑛𐑱","·𐑑𐑵𐑟𐑛𐑱","·𐑢𐑧𐑙𐑟𐑛𐑱","·𐑔𐑻𐑟𐑛𐑱","·𐑓𐑮𐑲𐑛𐑱","·𐑕𐑨𐑛𐑻𐑛𐑱"],["·𐑕𐑭","·𐑥𐑭","·𐑑𐑵","·𐑢𐑧","·𐑔𐑻","·𐑓𐑮","·𐑕𐑨"]],u,[["𐑡","𐑓","𐑥","𐑱","𐑥","𐑡","𐑡","𐑪","𐑕","𐑷","𐑯","𐑛"],["·𐑡𐑨","·𐑓𐑧","·𐑥𐑸","·𐑱𐑐","·𐑥𐑱","·𐑡𐑵","·𐑡𐑫","·𐑪𐑜","·𐑕𐑧","·𐑷𐑒","·𐑯𐑴","·𐑛𐑭"],["·𐑡𐑨𐑙𐑘𐑭𐑢𐑺𐑰","·𐑓𐑧𐑚𐑘𐑵𐑢𐑺𐑰","·𐑥𐑸𐑗","·𐑱𐑐𐑮𐑭𐑤","·𐑥𐑱","·𐑡𐑵𐑯","·𐑡𐑫𐑤𐑲","·𐑪𐑜𐑭𐑕𐑑","·𐑕𐑧𐑐𐑑𐑧𐑥𐑚𐑸","·𐑷𐑒𐑑𐑴𐑚𐑸","·𐑯𐑴𐑝𐑧𐑥𐑚𐑸","·𐑛𐑭𐑕𐑧𐑥𐑚𐑸"]],u,[["𐑚","𐑨"],["𐑚·𐑒","𐑨𐑛"],["𐑚𐑰𐑓𐑪𐑮 ·𐑒𐑮𐑲𐑕𐑑","𐑨𐑙𐑴 𐑛𐑪𐑥𐑦𐑙𐑰"]],1,[6,0],["y-MM-dd","y MMM d","y MMMM d","y MMMM d, EEEE"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤ #,##0.00","#E0"],"GBP","£",u,{"JPY":["JP¥","¥"],"USD":["US$","$"]},"ltr", plural];
